import { render, staticRenderFns } from "./DWorkspaceGroupBreadcrumb.vue?vue&type=template&id=6c8ffd5f&scoped=true&"
import script from "./DWorkspaceGroupBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DWorkspaceGroupBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./DWorkspaceGroupBreadcrumb.vue?vue&type=style&index=0&id=6c8ffd5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ffd5f",
  null
  
)

export default component.exports